import "../styles/tournaments.css"
import knight from "../assets/images/knight_tilt.png"
import king from "../assets/images/king.png"
import queen from "../assets/images/hero-queen.png"
import TourCard from "../components/TourCard"
import ScoreCard from "../components/ScoreCard"
import { useEffect, useState } from "react"
import tour_1 from "../assets/images/t-1.png";
import tour_2 from "../assets/images/t-2.png";
import { useNavigate } from "react-router-dom";
import Queen from "../components/Queen";
import { API_CONFIG } from "../config/api";
import { generateAuthToken,generateURN } from "../components/hmac";


function formatTournamentDate(startDateStr, durationDays = 3) {
  const start = new Date(startDateStr);
  const end = new Date(start);
  end.setDate(start.getDate() + durationDays - 1);

  const month = start.toLocaleString("en-US", { month: "long" });
  const startDay = start.getDate();
  const endDay = end.getDate();

  return `${month} ${startDay}-${endDay}`;
}



const Tournaments = () => {

  const [tourData,setTourData]=useState([]);
  const [resultData,setResultData]=useState([]);
  const tourImages = [tour_1, tour_2];
  const navigate = useNavigate();



  useEffect(() => {
      fetchTours();
  }, []);

  useEffect(() => {
      fetchResults();
  }, []);




  const fetchTours=async()=>{
    try{
      const { host, fetchTournaments,basic } = API_CONFIG;
      const urn=generateURN();
      const authToken=generateAuthToken(urn);
      const res = await fetch(
        `https://${host}${fetchTournaments.path}`,
        {
          method: fetchTournaments.method,
          credentials: "include",
          headers:{
            Authorization:`Basic ${basic.BASIC_AUTH_CWUSER}`,
            urn:urn,
            authToken:authToken,
          }
        }
      );
      const json=await res.json();
      const data=json.apiResponseData.responseData.tournaments;
      setTourData(data);
    }catch(error){
      console.error("API ERROR",error);
    }
  }

  const fetchResults=async()=>{
    try{
      const { host, fetchResults,basic } = API_CONFIG;
      const urn=generateURN();
      const authToken=generateAuthToken(urn);
      const res = await fetch(
        `https://${host}${fetchResults.path}`,
        {
          method: fetchResults.method,
          credentials: "include",
          headers:{
            Authorization:`Basic ${basic.BASIC_AUTH_CWUSER}`,
            urn:urn,
            authToken:authToken,
          }
        }
      );
      const json=await res.json();
      const data=json.apiResponseData.responseData.results;
      setResultData(data);
    }catch(error){
      console.error("API ERROR",error);
    }
  }


  return (

    <section className="tournaments-page">
      <Queen/>
      <div className="banner">
        <img className="pieces" src={king} alt="king"/>
        <h1>Tournaments</h1>
        <img className="pieces" src={knight} alt="knight"/>
        <div className="ribbon"></div>
      </div>


      <div className="tours">
        {tourData.map((item,index)=>(
          <TourCard 
          image={tourImages[index % 2]}
          title={item.tournamentName}
          date={formatTournamentDate(item.date, 2)}
          info={item.info} 
          onDetails={() => navigate(`/tournaments/${item.tournamentID}`)}
          />
        ))}
      </div>

      <div className="latest">
        <img id="queen" src={queen} alt="queen"/>
        <h1>Latest Result</h1>
        <div className="ribbon_2"></div>
      </div>

        
      <div className="leaderBoard">
        {resultData.map((item, index) => {
            if (!Array.isArray(item.players) || item.players.length < 3) {
              return null; 
            }
          const tournament = tourData.find(t => t.tournamentID === item.tournamentID);
          return (
            <ScoreCard
              title={tournament?.tournamentName}
              p1={item.players[0].name}
              p2={item.players[1].name}
              p3={item.players[2].name}
              onDetails={() => navigate(`/results/${item.resultID}`)}
            />
          );
        })}
      </div> 

    </section>
  );
};

export default Tournaments;

